var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-container',[_c('el-header',{attrs:{"height":"auto"}},[_c('MyHeader')],1),_c('el-main',[_c('MyMain')],1),_c('el-footer',{attrs:{"height":"140px"}},[_c('MyFooter')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }